<template>
  <!-- <PrsonalInfo v-if="(totalChild == 0) && !['ROLE_ADMIN,', 'ROLE_ADMIN'].includes(roles)" /> -->

  <!-- <EmployeeDashboard v-else-if="(totalChild != 0) || ['ROLE_ADMIN,', 'ROLE_ADMIN'].includes(roles)" /> -->

  <EmployeeDashboard />
</template>

<script>
  /* eslint-disable */
  import { ref, onMounted, onBeforeMount, computed, watchEffect, reactive } from 'vue'
  import { useStore } from 'vuex'
  import { mdiCheckBold, mdiPlusCircleOutline, mdiClose } from '@mdi/js'
  import { useRouter } from 'vue-router'
  import axios from 'axios'

  import DashboardLeave from './Dashboard/HRD/DashboardLeave.vue'
  import PrsonalInfo from '@/views/EmployeeInfo.vue'
  import EmployeeDashboard from '@/views/EmployeeDashboard.vue'

  export default {
    name: 'HomeHRD',

    components: {
      DashboardLeave,
      PrsonalInfo,
      EmployeeDashboard
    },

    setup (props, { emit }) {
      // const totalChild = Number(localStorage.getItem('child'))
      const userId = computed(() => localStorage.getItem('user_id'))
      const totalChild = ref(0)
      const roles = localStorage.getItem('roles')

      const getData = async () => {
        const thisDate = new Date()
        let thisYear = thisDate.getFullYear()
        let thisMonth = ('0' + (thisDate.getMonth() + 1)).slice(-2)
        const monthNow = (thisYear + '-' + thisMonth)

        const headers = {'Content-Encoding': 'gzip'}

        const testParams1 = {
          user_id: userId.value,
          is_personal: 0,
          year: thisYear,
          month: thisMonth
        }

        try {
          const [response1] = await Promise.all([
            axios.get("get-leave-history", { headers, params: testParams1 })
          ])

          if(response1.data.data) {
            const backData = response1.data.data
            // console.log("cek back data", backData)

            if(backData.length != 0) {
              if(backData[0].child_list) {
                totalChild.value = backData[0].child_list.length
              }
            }
          }
        }
        catch(error) {
          console.log(error)
        }
      }

      onBeforeMount(() => {
        getData()
      })

      return {
        userId,
        totalChild,
        roles
      }
    }
  }
</script >
